export const SKIP_TO_CONTENT = 'SKIP_TO_CONTENT';

export const skipToContent = userSkip => ({
  type: SKIP_TO_CONTENT,
  payload: userSkip,
});
